<template>
  <el-table
    :data="knowledgeWrongList"
    ref="correlation"
    style="width: 100%"
    class="correlation"
    :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
    @selection-change="handleSelectionChange"
    >
    <div slot="empty" class="no-data">
      <emptyContent/>
    </div>
     <el-table-column
      type="selection"
      align="center"
      width="50">
    </el-table-column>
    <el-table-column
      label="题目"
      prop="body.content">
      <template slot-scope="scope">
         <div v-katexHtml="scope.row.body.content"></div>
         <span v-for="k in scope.row.body.img_data" :key="k.id">
           <img :src="k.source" />
         </span>
       </template>
    </el-table-column>
    <el-table-column
      label="正答率"
      prop="accuracy"
      align="center"
      width="100"
      sortable>
       <template slot-scope="scope">
         <div class="correlation-probability">
           <div v-if="scope.row.accuracy>=40&&scope.row.accuracy<70" style="color:#F99830">
               {{ scope.row.accuracy }}%
             </div>
              <div v-else-if="scope.row.accuracy>=70" style="color:#67C23A">
              {{ scope.row.accuracy }}%
             </div>
              <div v-else style="color:#F56C6C">
              {{ scope.row.accuracy }}%
             </div>
         </div>
       </template>
    </el-table-column>
    <el-table-column
      prop="wrongCnt"
      align="center"
      width="120"
      label="答错人数"
      sortable>
        <template slot-scope="scope">
         <div class="correlation-people">
           {{ scope.row.wrongCnt }}人
         </div>
       </template>
    </el-table-column>
    <!-- 操作 -->
    <el-table-column label="操作" width="100px" align="right">
         <template slot-scope="scope">
            <div @click="rowToggle(scope.$index, scope.row)">
              <el-button
                size="mini"
                type="text"
                >查看明细</el-button>
            </div>
          </template>
        </el-table-column>
    <!-- 展开行 -->
    <el-table-column  type="expand" align="left" width="40">
      <template slot-scope="props">
        <Knowledge :topicInfo='props' v-bind="$attrs" />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Knowledge from '@/components/knowledge.vue';
import emptyContent from '@/views/pt/components/empty-content.vue';

export default {
  components: {
    Knowledge,
    emptyContent,
  },
  props: {
    knowledgeWrongList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [], // 选中的题目
    };
  },
  watch: {
    knowledgeWrongList(val) {
      this.tableData = val;
    },
  },

  methods: {
    rowToggle(index, row) { // 点击按钮展开显示
      // console.log(index, row);
      const { correlation } = this.$refs;
      correlation.toggleRowExpansion(row);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit('multipleSelection', this.multipleSelection);
    },
    clearchange() {
      this.$refs.correlation.clearSelection();
    },
  },
};
</script>
<style lang="scss" scoped>
  .correlation {
    .no-data{
      line-height: 1.8;padding: 30px 0;
    }
    font-family: 'PingFangSC-Semibold', 'PingFang SC';
    /deep/ .el-table__expanded-cell {
      padding:  0px;
    }
    /deep/ .el-icon-arrow-right:before {
        content: "\e790";
    }
    /deep/ .el-table__expand-icon--expanded {
      transform: rotate(180deg);
    }
    /deep/ .el-table__expand-icon  {
      left: -15px;
    }
    .el-button--mini /deep/ span {
      position: relative;
      left: 8px;
    }
    &-probability {
      font-size: 14px;
      font-weight: 600;
      color: #67C23A;
    }
    &-people {
      font-size: 14px;
      font-weight: 600;
      color: #F56C6C;
    }
  }
</style>
